export const tabNames = [
  { value: 'quick', name: 'Quick Math' },
  { value: 'greek', name: 'Greek' },
  { value: 'relations', name: 'Relations' },
  { value: 'logics', name: 'Logics' },
  { value: 'calculus', name: 'Calculus' },
];

export const tabTest = [];
